import axios from '@/libs/api.request'
// 获取所有的导师
export const getJointAll = data => {
  return axios.request({
    url: '/joint/map/all',
    data,
    method: 'POST'
  })
}
// 获取SMCM导师
export const getJointSMCM = data => {
  return axios.request({
    url: '/joint/map/smcm',
    data,
    method: 'POST'
  })
}
// 获取SM导师
export const getJointSM = data => {
  return axios.request({
    url: '/joint/list/sm',
    data,
    method: 'POST'
  })
}
// 获取EM导师
export const getJointEM = data => {
  return axios.request({
    url: '/joint/list/em',
    data,
    method: 'POST'
  })
}
// 获取EM导师
export const getJointCM = data => {
  return axios.request({
    url: '/joint/list/cm',
    data,
    method: 'POST'
  })
}
// 获取导师详情
export const getJointDetail = data => {
  return axios.request({
    url: '/joint/detail',
    data,
    method: 'POST'
  })
}
// 服务团队的导师预约
export const getJointConfirmMentor = data => {
  return axios.request({
    url: '/joint/confirm/pre/mentor',
    data,
    method: 'POST'
  })
}
